import React from 'react'
import { Box, TextHeading, Space, useMediaSize } from '@ally/metronome-ui'
import styled from 'styled-components'
import CustomizeModalTrigger from '../CustomizeDashboard/CustomizeModalTrigger'
import { useAccountTypes } from '../AccountTypeContext'

const InvisibleForPrint = styled(Box)`
  @media print {
    visibility: hidden;
  }
`

const LobShell: React.FC<{
  header: string
  customizeTriggerLob: string
}> = ({ children, header, customizeTriggerLob }) => {
  const { hasSingleAccountType } = useAccountTypes()
  const showCustomizationTrigger = useMediaSize('LgUp') && !hasSingleAccountType

  return (
    <>
      <Box
        mb="sm"
        ml={
          showCustomizationTrigger
            ? '-18px'
            : // istanbul ignore next
              '0'
        }
        display="flex"
        alignItems="center"
      >
        {
          // istanbul ignore next
          showCustomizationTrigger ? (
            <InvisibleForPrint>
              <CustomizeModalTrigger lob={customizeTriggerLob} triggerIsIcon />
            </InvisibleForPrint>
          ) : null
        }
        <Space mr="sm">
          <TextHeading tag="h2" size="md" white-space="nowrap" min-width="30%">
            {header}
          </TextHeading>
        </Space>
      </Box>
      {children}
    </>
  )
}

export default LobShell
